import { ReactNode, useState } from 'react';

import { DebouncedSearch } from './debounced-search';

export interface FilteredSearchProps<T> {
  children: (filtered: T[]) => ReactNode;
  className?: string;
  data: T[];
  filterFn: (data: T[], term: string) => T[];
  placeholder?: string;
}

export function FilteredSearch<T>({
  children,
  className,
  data,
  filterFn,
  placeholder = 'Search',
}: FilteredSearchProps<T>) {
  const [term, setTerm] = useState('');
  const filteredData = filterFn(data, term);

  return (
    <>
      <DebouncedSearch
        className={className}
        defaultValue={term}
        placeholder={placeholder}
        onChange={setTerm}
      />
      {children(filteredData)}
    </>
  );
}
